

import { useEffect, useState } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";

const NewSupplier1 = ({ item,onAddDepart  }) => {
    const [formData, setFormData] = useState({
        user_id:'',
        fname:'',
        gender:'',
        mobile:'',
        city:'',
        state:'',
        address_line1:'',
        address_line2:'',
        pincode:'',
        gstin:'',
        dlno:'',
        type: 'supplier1',
        alertMsg: '',
        alertMsgTyp: '',
        isAlert: false,
      });
      const [ldata, setLdata] = useState(null);

      const handleChange = (e) => {
       
        const { name, value } = e.target;
        setFormData(prev => ({
          ...prev,
          [name]: value
        }));
      };

      const handleSubmit = async (e) => {
        e.preventDefault();
        // alert(formData.email+"");
        const fd = new FormData();
        fd.append('user_id', formData.user_id);
        fd.append('fname', formData.fname);
        fd.append('gender', formData.gender);
        fd.append('city', formData.city);
        fd.append('state', formData.state);
        fd.append('type', formData.type);
        fd.append('address_line1', formData.address_line1);
        fd.append('address_line2', formData.address_line2);
        fd.append('mobile', formData.mobile);
        fd.append('pincode', formData.pincode);
        fd.append('dlno', formData.dlno);
        fd.append('gstin', formData.gstin);
        fd.append('user_cre_by', ldata.user_id);
        
        try {
            const response = await axios.post(AppConst.BASE_URL+AppConst.addUserUrl, fd, {
                headers: {
                'Content-Type': 'multipart/form-data',
                },
            });

            if(response.data.status){
                setFormData(prev => ({
                    ...prev,
                    isAlert: true,
                    alertMsg: response.data.success,
                    alertMsgTyp: response.data.type,
                  }));
                  document.getElementById("closeBt45").click();
                  onAddDepart();
            }
            else{
                setFormData(prev => ({
                    ...prev,
                    isAlert: true,
                    alertMsg: response.data.success,
                    alertMsgTyp: response.data.type,
                  }));
            }
        } catch (error) {
            setFormData(prev => ({
                ...prev,
                isAlert: true,
                alertMsg: "Failed",
                alertMsgTyp: "danger",
              }));
        }
        
      };

    useEffect(() => {
        console.log('Component mounted');
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);
            setLdata(parsed);
        }  

        if (item) {
            console.log("Editing item:", item);
            if(item!=null && item!=undefined){
                setFormData(prev => ({
                    ...prev,
                    fname: item.fname,
                    gender: item.gender,
                    city: item.city,
                    state: item.state,
                    type: item.type,
                    address_line1: item.address_line1,
                    address_line2: item.address_line2,
                    pincode: item.pincode,
                    gstin: item.gstin,
                    dlno: item.dlno,
                    mobile: item.mobile,
                    user_id: item.user_id,
                  }));
                }
          }
          else{
            setFormData(prev => ({
                ...prev,
                user_id:'',
                fname:'',
                gender:'',
                mobile:'',
                city:'',
                state:'',
                address_line1:'',
                address_line2:'',
                pincode:'',
                gstin:'',
                dlno:'',
                type: 'supplier1',
                
              }));
          }
          
        return () => {
          console.log('Component unmounted');
        };
      }, [item]);
    return (
        <div class="modal fade" id="showModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-header bg-light p-3">
                        <h5 class="modal-title" id="exampleModalLabel">&nbsp;</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close-modal"></button>
                    </div>
                    <form class="tablelist-form" onSubmit={handleSubmit}>
                        <div class="modal-body">
                            <input id="id-field" type="hidden" />
                            <div class="row gy-4 mb-3">
                                
                                <div class="col-md-6">
                                    <div >
                                        <label for="customername-field" class="form-label">Supplier Name</label>
                                        <input  name="fname" onChange={handleChange} value={formData.fname} class="form-control" placeholder="Enter name" type="text"  required/>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div >
                                        <label for="customername-field" class="form-label">Contact</label>
                                        <input  name="mobile" onChange={handleChange} value={formData.mobile} class="form-control" placeholder="Enter Contact" type="text" required/>
                                    </div>
                                </div>
                                
                                <div class="col-md-6">
                                    <div >
                                        <label for="customername-field" class="form-label">Address Line 1</label>
                                        <input  name="address_line1" onChange={handleChange} value={formData.address_line1} class="form-control" placeholder="Enter Address" type="text" required />
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div >
                                        <label for="customername-field" class="form-label">Address Line 2</label>
                                        <input  name="address_line2" onChange={handleChange} value={formData.address_line2} class="form-control" placeholder="Enter Address" type="text" />
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div >
                                        <label for="customername-field" class="form-label">City</label>
                                        <input  name="city" onChange={handleChange} value={formData.city} class="form-control" placeholder="Enter City" type="text" />
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div >
                                        <label for="customername-field" class="form-label">State</label>
                                        <input  name="state" onChange={handleChange} value={formData.state} class="form-control" placeholder="Enter City" type="text" />
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div >
                                        <label for="customername-field" class="form-label">Pincode</label>
                                        <input  name="pincode" onChange={handleChange} value={formData.pincode} class="form-control" placeholder="Enter Pincode" type="text" required />
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div >
                                        <label for="customername-field" class="form-label">DLNO</label>
                                        <input  name="dlno" onChange={handleChange} value={formData.dlno} class="form-control" placeholder="Enter DLNO" type="text" required/>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div >
                                        <label for="customername-field" class="form-label">GSTIN</label>
                                        <input  name="gstin" onChange={handleChange} value={formData.gstin} class="form-control" placeholder="Enter GSTIN" type="text" required/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <div class="hstack gap-2 justify-content-end">
                                <button type="button" id="closeBt45" class="btn btn-light" data-bs-dismiss="modal">Close</button>
                                <button type="submit" class="btn btn-success" id="edit-btn">Add</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default NewSupplier1;
